<template>
  <div class="ingredient">
    <div class="search_warp">
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="名称">
          <el-input v-model.trim="searchForm.searchValue" placeholder="请输入辅料名称" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 操作按钮 -->
    <div class="action_warp">
      <el-button icon="el-icon-plus" type="primary" @click="openDialog">新增辅料</el-button>
    </div>
    <div class="table_warp">
      <el-table :max-height="600" :data="table" border>
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column prop="ingredientsName" label="辅料名称" />
        <el-table-column prop="unit" label="单位" />
        <el-table-column prop="updateBy" label="操作人" />
        <el-table-column prop="updateTime" label="操作时间" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="gageChange" :total="total" :current-page="searchForm.pageNum" class="mt16"
        :page-size="searchForm.pageSize" layout="total, prev, pager, next, jumper" />
    </div>
    <el-dialog v-if="dialogVisible" :title="form.ingredientsId ? '修改辅料' : '新增辅料'" :visible.sync="dialogVisible"
      width="450px" @close="closeDialog">
      <el-form :model="form" ref="editForm" :rules="rules" label-width="80px">
        <el-form-item label="辅料名称" prop="ingredientsName">
          <el-input v-model.trim="form.ingredientsName" clearable placeholder="请输入辅料名称" />

        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-autocomplete v-model="form.unit" placeholder="请输入或者选择单位" :fetch-suggestions="querySearch" @select="handleSelect"></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="save">保存</el-button>
        <el-button @click="closeDialog">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ingredientsList, ingredientsAdd, ingredientsEdit, ingredientsDelete } from '@/api/ingredients'
import { getDict } from '@/api/common'
import { debounce, deepClone, isNull } from '@/utils/validateBase';
export default {
  data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        searchValue: '',
      },
      total: 0,
      table: [],
      dialogVisible: false,
      form: {
        ingredientsName: '',
        unit: ''
      },
      rules: {
        ingredientsName: [{ required: true, message: '请输入辅料名称', trigger: 'blur' }],
        unit: [
          { required: true, message: '请输入或者选择单位', trigger: 'change' },
          { max: 5, message: '不能超过5个字符', trigger: 'blur'}
        ],
      },
      uintDict:[],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getDictData(){
      let {code,data} = await getDict('INGREDIENTS_UNIT')
      if(code == 200){
        this.uintDict = data.map(v=>{ return {value:v.dictLabel} })
      }
    },
    async getList() {
      let { code, rows, total } = await ingredientsList(this.searchForm)
      if (code == 200) {
        this.table = rows || []
        this.total = total
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.form = { ingredientsName: '', unit: '' }
    },
    save: debounce(function () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          if (isNull(this.form.ingredientsId)) {
            ingredientsAdd(this.form).then(res => {
              if (res.code == 200) {
                this.$message.success('保存成功')
                this.closeDialog()
                this.searchForm.pageNum = 1
                this.getList()
              }
            })
          } else {
            ingredientsEdit(this.form).then(res => {
              if (res.code == 200) {
                this.$message.success('修改成功')
                this.closeDialog()
                this.getList()
              }
            })
          }
        }
      })
    }, 500, true),

    openDialog() {
      this.getDictData()
      this.dialogVisible = true
    },
    gageChange(page) {
      this.searchForm.pageNum = page
      this.getList()
    },
    handleSearch() {
      this.searchForm.pageNum = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 10,
        searchValue: '',
      }
      this.getList()
    },
    handleEdit(row) {
      this.getDictData()
      this.form = deepClone(row)
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ingredientsDelete(row.ingredientsId).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功')
            this.getList()
          }
        })
      }).catch(() => { });
    },
    querySearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      console.log(this.uintDict,9999);
      
      cb(this.uintDict);
    },
    handleSelect(item) {
      this.form.unit = item.value
    }
  }
}
</script>

<style lang="less" scoped>
.ingredient {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.search_warp {
  padding: 16px;
}

.action_warp {
  padding-left: 16px;
}

.table_warp {
  margin-top: 16px;
  padding: 0 16px;
  flex: 1;
  overflow: auto;
}
</style>